/**
 * Shared between the consumer ordering app and the back office, which is why it
 * sits here rather than in either one. Both render this value and the admin
 * writes it; three separate declarations of it drifted before this file.
 *
 * Mirrors `domain/Ordering/Enums/MenuLayout.php`.
 *
 * How a venue draws its menu. A rendering choice only — the payload is
 * identical either way.
 *
 * The trade is photographs against prices. ROWS shows large artwork where a
 * dish has one and plain text where it does not; TEXT drops artwork to buy a
 * right-aligned price column and roughly twice the dishes per screen.
 */
const MENU_LAYOUT = {
  ROWS: 'rows',
  TEXT: 'text'
} as const

type MenuLayout = (typeof MENU_LAYOUT)[keyof typeof MENU_LAYOUT]

export { MENU_LAYOUT }
export type { MenuLayout }
